import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  Button,
  Dropdown,
  Table,
  Spinner,
  ToastContainer,
  Toast,
} from "react-bootstrap";
import {
  FiChevronLeft,
  FiMapPin,
  FiMail,
  FiPhone,
  FiMoreVertical,
  FiCheckCircle,
  FiUser,
  FiXCircle,
} from "react-icons/fi";
import { FaTruck, FaRupeeSign } from "react-icons/fa";
import Sidebar from "../../common/Sidebar";
import {
  getVendorEditApi,
  getProductListApi,
  updateVendorStatusApi,
  deleteVendorApi,
} from "./vendor-api";
import LoaderModal from "../../common/loader";
import DeleteModal from "../../common/deleteModel";
import moreIcon from "../../../assets/svg/more_ic.svg";
import { Navbar } from "../../common/Navbar";
import { useGlobal } from "../../../GlobalContext";

const VendorView = () => {
  const { rolePermissionList, userType } = useGlobal();
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {};
  const [vendor, setVendor] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isStatusUpdating, setIsStatusUpdating] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  function checkPermission(permission) {
    return rolePermissionList.findIndex(
      (element) =>
        element["name"] === "Vendor" &&
        element["menu_permission"] === true &&
        element[permission] === true
    ) > -1
      ? true
      : false;
  }

  useEffect(() => {
    if (deleteId !== null) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);
  const deleteVendor = async () => {
    try {
      const response = await deleteVendorApi(deleteId);
      if (response.data.success === true) {
        navigate(-1);
        setDeleteId(null);
        setIsOpenDelete(false);
      }
      if (response.data) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        setShowSnackbar(true);
      }
    } catch (err) {
      console.error("Error deleting product:", err);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      if (id) {
        try {
          const response = await getVendorEditApi(id);
          if (response.data && response.data.success) {
            setVendor(
              response.data.vendors || response.data.data || response.data
            );
          }

          const productResponse = await getProductListApi({ vendor_id: id });
          if (productResponse.data && productResponse.data.success) {
            setProducts(
              productResponse.data.products || productResponse.data.data || []
            );
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setLoading(false);
        }
      }
    };
    fetchData();
  }, [id]);

  const handleStatusUpdate = async (newStatus) => {
    if (!vendor) return;
    setIsStatusUpdating(true);
    try {
      const response = await updateVendorStatusApi(vendor.id, {
        status: newStatus,
      });
      if (response.data && response.data.success) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        setShowSnackbar(true);
        setVendor((prev) => ({ ...prev, status: newStatus }));
      } else {
        console.error("Failed to update status");
      }
    } catch (error) {
      console.error("Error updating status:", error);
    } finally {
      setIsStatusUpdating(false);
    }
  };

  if (loading) {
    return (
      <div
        className="d-flex"
        style={{
          backgroundColor: "#f8f9fa",
          minHeight: "100vh",
          fontFamily: "'Inter', sans-serif",
        }}
      >
        <Sidebar currentfile="Vendors" />
        <LoaderModal show={true} />
      </div>
    );
  }

  if (!vendor) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <p>Vendor not found.</p>
      </div>
    );
  }

  return (
    <>
      <LoaderModal show={isLoading} />
      <DeleteModal
        title={"vendor"}
        isOpen={isOpenDelete}
        onClose={() => {
          setIsOpenDelete(false);
          setDeleteId(null);
        }}
        onDelete={deleteVendor}
      />
      <div
        className="d-flex"
        style={{
          backgroundColor: "#f8f9fa",
          minHeight: "100vh",
          fontFamily: "'Inter', sans-serif",
        }}
      >
        <Sidebar currentfile="Vendors" />

        <div
          style={{
            width: "calc(100vw - 80px)",
            overflowY: "auto",
            height: "100vh",
          }}
        >
          <Navbar pageTitle="Vendor" />
          {/* Header Section */}
          <div className="p-3">
            <div className="bg-white rounded shadow-sm p-3 mb-3">
              <div className="d-flex justify-content-between align-items-start">
                <div className="d-flex gap-3">
                  <Button
                    variant="light"
                    className="rounded-circle d-flex align-items-center justify-content-center border"
                    style={{ width: "40px", height: "40px" }}
                    onClick={() => navigate(-1)}
                  >
                    <FiChevronLeft size={20} />
                  </Button>

                  <div className="d-flex gap-3">
                    <div
                      className=" d-flex align-items-center justify-content-center overflow-hidden"
                      style={{
                        width: "48px",
                        height: "48px",
                        borderRadius: "12px",
                        backgroundColor: vendor.upload ? "" : "#FF3B30",
                      }}
                    >
                      {vendor.upload ? (
                        <img
                          src={vendor.upload}
                          alt="Vendor"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <FaTruck color="white" size={24} />
                      )}
                    </div>

                    <div className="text-start">
                      <div className="d-flex align-items-center gap-2 mb-1">
                        <h4 className="m-0 fw-bold fs-18">
                          {vendor.vendor_name}
                        </h4>
                      </div>
                      <div className="fs-12 text-muted">{vendor.type}</div>
                    </div>
                  </div>
                </div>

                <div className="d-flex flex-column align-items-end gap-2">
                  <div className="d-flex align-items-center gap-2">
                    {checkPermission("edit_permission") && (
                      <Dropdown>
                        <Dropdown.Toggle
                          variant="white"
                          className="border rounded-pill px-3 py-1 d-flex align-items-center gap-2 fs-13"
                          style={{
                            color: vendor.status ? "#198754" : "#dc3545",
                          }}
                        >
                          {isStatusUpdating ? (
                            <Spinner animation="border" size="sm" />
                          ) : (
                            <>
                              <span
                                className={`rounded-circle ${
                                  vendor.status ? "bg-success" : "bg-danger"
                                }`}
                                style={{ width: "8px", height: "8px" }}
                              ></span>
                              {vendor.status ? "Active" : "Inactive"}
                            </>
                          )}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() => handleStatusUpdate(true)}
                          >
                            Active
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => handleStatusUpdate(false)}
                          >
                            Inactive
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    )}

                    {/* <Button
                    variant="primary"
                    className="px-3 py-1 fs-13 rounded"
                    style={{
                      backgroundColor: "#3469E7",
                      borderColor: "#3469E7",
                    }}
                    onClick={() =>
                      navigate("/vendor/create", { state: { id: vendor.id } })
                    }
                  >
                    Edit
                  </Button> */}

                    <div className="d-flex flex-row flex-grow-1 align-items-end justify-content-end gap-2 ps-3">
                      <div onClick={(e) => e.stopPropagation()}>
                        {(checkPermission("edit_permission") ||
                          checkPermission("delete_permission")) && (
                          <Dropdown>
                            <Dropdown.Toggle
                              bsPrefix="custom-toggle"
                              variant="light"
                              id="dropdown-sort"
                              className="d-flex align-items-center justify-content-between rounded-5 bg-white"
                              style={{
                                width: "36px",
                                height: "36px",
                                border: "1px solid #EBEBEB",
                              }}
                            >
                              <span className="d-flex align-items-center px-1 gap-2">
                                <img src={moreIcon} alt="more" />
                              </span>
                            </Dropdown.Toggle>

                            <Dropdown.Menu
                              style={{
                                backgroundColor: "white",
                                borderRadius: "8px",
                                border: "1px solid #EBEBEB",
                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                              }}
                            >
                              {checkPermission("edit_permission") && (
                                <Dropdown.Item
                                  className="fs-14 fw-500 textcolor"
                                  onClick={() => {
                                    navigate("/vendor/create", {
                                      state: { id: vendor.id },
                                    });
                                  }}
                                >
                                  Edit
                                </Dropdown.Item>
                              )}
                              {checkPermission("delete_permission") && (
                                <Dropdown.Item
                                  className="fs-14 fw-500 textcolor"
                                  onClick={() => {
                                    setDeleteId(id);
                                  }}
                                >
                                  Delete
                                </Dropdown.Item>
                              )}
                            </Dropdown.Menu>
                          </Dropdown>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-between w-100 mt-2">
                {/* Left Section (Phone + Email) */}
                <div className="d-flex align-items-center gap-3">
                  <div className="d-flex align-items-center gap-2 fs-13 text-muted">
                    <FiPhone className="text-primary" />

                    {vendor.mobilenumber?.trim() ? vendor.mobilenumber : "-"}
                  </div>

                  <div className="d-flex align-items-center gap-2 fs-13 text-muted">
                    <FiMail className="text-primary" />
                    {vendor.email?.trim() ? vendor.email : "-"}
                  </div>
                </div>

                {/* Right Section (Login required) */}
                {/* <div
                  className={`d-flex align-items-center gap-1 fs-12 fw-500 ${
                    vendor.login_require ? "text-success" : "text-muted"
                  }`}
                >
                  {vendor.login_require ? <FiCheckCircle /> : <FiXCircle />}{" "}
                  Login Required
                </div> */}
              </div>
            </div>

            <Row className="g-3 mb-3">
              {/* Vendor Details Card */}
              <Col md={6}>
                <Card className="border-0 shadow-sm h-100 text-start">
                  <Card.Body className="p-4">
                    <h6 className="fw-bold mb-4">Vendor details</h6>

                    <div className="d-flex justify-content-between mb-3">
                      <span className="text-muted fs-14 d-flex align-items-center gap-2">
                        {/* <FiUser size={16} /> */}
                        Vendor ID
                      </span>
                      <span className="fw-bold fs-14">{vendor.vendor_id}</span>
                    </div>

                    <div className="d-flex justify-content-between mb-4">
                      <span className="text-muted fs-14 d-flex align-items-center gap-2">
                        GST NO
                      </span>
                      <span className="fw-bold fs-14">
                        {vendor.gst_number || "-"}
                      </span>
                    </div>

                    <div
                      className="border rounded-4 p-3 bg-white"
                      style={{ borderStyle: "dashed" }}
                    >
                      <p className="text-muted fs-12 mb-3">
                        Bank Account Information
                      </p>
                      <div className="d-flex align-items-center gap-3">
                        <div
                          className="rounded-circle d-flex align-items-center justify-content-center fw-bold fs-18"
                          style={{
                            width: "48px",
                            height: "48px",
                            backgroundColor: "#E8F0FE",
                            color: "#3469E7",
                          }}
                        >
                          {vendor.bank_account_name
                            ? vendor.bank_account_name.charAt(0).toUpperCase()
                            : "N"}
                        </div>
                        <div>
                          <div className="fw-bold fs-14">
                            {vendor.bank_account_name || "-"}
                          </div>
                          <div className="d-flex align-items-center gap-2 fs-13 text-muted">
                            {vendor.bank_account_number || "-"}
                            <span className="text-muted">•</span>
                            <span className="badge bg-white text-primary border px-2 py-1 fw-normal">
                              IFSC Code : {vendor.ifsc_code || "-"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>

              {/* Address Cards */}
              <Col md={6}>
                <div className="d-flex flex-column gap-3 h-100 text-start">
                  <Card className="border-0 shadow-sm flex-fill">
                    <Card.Body className="p-4">
                      <h6 className="fw-bold mb-3">Billing address</h6>
                      <div className="d-flex gap-3">
                        <div
                          className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                          style={{
                            width: "32px",
                            height: "32px",
                            backgroundColor: "#FFE5E5",
                          }}
                        >
                          <FiMapPin color="#FF3B30" size={16} />
                        </div>
                        <div>
                          <p className="fs-14 text-muted m-0 lh-base">
                            {vendor.billing_address}
                          </p>
                          <p className="fs-13 text-muted m-0">
                            {vendor.billing_city}, {vendor.billing_state},{" "}
                            {vendor.billing_country} - {vendor.billing_zipcode}
                          </p>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>

                  <Card className="border-0 shadow-sm flex-fill">
                    <Card.Body className="p-4">
                      <h6 className="fw-bold mb-3">Description</h6>
                      <div className="d-flex gap-3">
                        <div>
                          <p className="fs-14 text-muted m-0 lh-base">
                            {vendor.description || "No description provided."}
                          </p>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </Col>
            </Row>
          </div>

          {/* Products Section */}
          {/* <Card className="border-0 shadow-sm mt-3 text-start">
          <Card.Body className="p-4">
            <h6 className="fw-bold mb-4">Products</h6>
            <div className="table-responsive">
              <Table hover className="align-middle mb-0">
                <thead className="bg-light">
                  <tr>
                    <th className="text-muted text-uppercase fs-12 fw-bold border-0 bg-light py-3 ps-3">Product ID</th>
                    <th className="text-muted text-uppercase fs-12 fw-bold border-0 bg-light py-3">Name</th>
                    <th className="text-muted text-uppercase fs-12 fw-bold border-0 bg-light py-3 pe-3">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {products.length > 0 ? (
                    products.map((product, index) => (
                      <tr key={index}>
                        <td className="fw-bold fs-14 py-3 ps-3 border-bottom-0">{product.product_id || product.code}</td>
                        <td className="fs-14 py-3 border-bottom-0">{product.product_name || product.name}</td>
                        <td className="py-3 pe-3 border-bottom-0">
                          <span
                            className={`badge px-3 py-2 rounded fw-normal fs-11 ${product.status === "Active" || product.status === 1 || product.status === true ? "bg-success-subtle text-success" : "bg-danger-subtle text-danger"}`}
                            style={{
                              backgroundColor: product.status === "Active" || product.status === 1 || product.status === true ? "#D4F7D4" : "#FFE9D5",
                              color: product.status === "Active" || product.status === 1 || product.status === true ? "#0F9D0F" : "#F57600",
                            }}
                          >
                            {product.status === "Active" || product.status === 1 || product.status === true ? "ACTIVE" : "INACTIVE"}
                          </span>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="text-center text-muted py-4">
                        No products found
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </Card.Body>
        </Card> */}
        </div>
      </div>
      <ToastContainer position="top-end">
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={() => setShowSnackbar(false)}
          delay={3000}
          autohide
        >
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
};

export default VendorView;
